export default "__VITE_ASSET__CRqwNk9h__"